"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

var _Contraction = _interopRequireDefault(require("../Contraction"));

var _lodash = require("lodash");

var _FontColor = _interopRequireDefault(require("./FontColor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PanoMenu = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(PanoMenu, _React$PureComponent);

  function PanoMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      init: false,
      category: [],
      selected: [],
      animation: false,
      seenScenes: [],
      openMenu: []
    });

    _defineProperty(_assertThisInitialized(_this), "initData", function () {
      var _this$props = _this.props,
          originalCategory = _this$props.originalCategory,
          scenes = _this$props.scenes;
      var res = (0, _utils.initData)(originalCategory, scenes);

      _this.updateSelected(res.data);
    });

    _defineProperty(_assertThisInitialized(_this), "updateSelected", function (category) {
      if (!category) {
        category = _this.state.category;
      }

      var scenesId = _this.props.scenesId;
      var selectedAll = (0, _utils.initSelected)(category, scenesId);
      var openMenu = [].concat(_this.state.openMenu);
      selectedAll.forEach(function (id) {
        if (openMenu.indexOf(id) < 0) {
          openMenu.push(id);
        }
      });

      _this.setState({
        category: category,
        init: true,
        selectedAll: selectedAll,
        openMenu: openMenu
      });

      return selectedAll;
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (item) {
      var _this$props2 = _this.props,
          switchCategoryShowFirstScene = _this$props2.switchCategoryShowFirstScene,
          onSceneChange = _this$props2.onSceneChange;

      if (!item.children) {
        onSceneChange && onSceneChange(item.id);
      } else {
        var openMenu = [].concat(_this.state.openMenu);
        var index = openMenu.indexOf(item.id);

        if (index >= 0) {
          openMenu.splice(index, 1);
        } else {
          if (switchCategoryShowFirstScene === 1) {
            var scenesId = _this.findFirstSceneId(item.children);

            onSceneChange && onSceneChange(scenesId);
          }

          openMenu.push(item.id);
        }

        _this.setState({
          openMenu: openMenu
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "findFirstSceneId", function (data) {
      for (var i = 0; i < data.length; i++) {
        var item = data[i];

        if (item.children) {
          return _this.findFirstSceneId(item.children);
        } else {
          return item.id;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenu", function (menu, level, leftLevel) {
      if (!menu) return null;
      var _this$props3 = _this.props,
          _this$props3$ui = _this$props3.ui,
          ui = _this$props3$ui === void 0 ? {} : _this$props3$ui,
          payScenes = _this$props3.payScenes;
      var _this$state = _this.state,
          selectedAll = _this$state.selectedAll,
          openMenu = _this$state.openMenu;
      var selected = selectedAll[level];
      return menu.map(function (item) {
        var isShow = openMenu.indexOf(item.id) >= 0;
        var showGroup = !item.children || menu.length > 1;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.id
        }, !showGroup ? null : /*#__PURE__*/_react["default"].createElement(_FontColor["default"], {
          ui: ui,
          disableBgColor: true,
          disableColorHover: true
        }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          payScenes: payScenes,
          isShow: isShow,
          selected: selected,
          onClick: _this.onClick.bind(_assertThisInitialized(_this), item),
          item: item,
          level: level,
          leftLevel: leftLevel
        })), /*#__PURE__*/_react["default"].createElement(_Contraction["default"], {
          isShow: isShow
        }, _this.renderMenu(item.children, level + 1, showGroup ? leftLevel + 1 : leftLevel)));
      });
    });

    return _this;
  }

  var _proto = PanoMenu.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.initData();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props4 = this.props,
        scenesId = _this$props4.scenesId,
        scenes = _this$props4.scenes,
        originalCategory = _this$props4.originalCategory;
    var prevScenesId = prevProps.scenesId,
        prevScenes = prevProps.scenes,
        prevOriginalCategory = prevProps.originalCategory;

    if (!(0, _lodash.isEqual)(scenes, prevScenes) || !(0, _lodash.isEqual)(originalCategory, prevOriginalCategory)) {
      this.initData();
    } else if (scenesId !== prevScenesId) {
      this.updateSelected();
    }
  };

  _proto.render = function render() {
    var init = this.state.init;
    if (!init) return null;
    var category = this.state.category;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: 20
      }
    }, this.renderMenu(category, 0, 0));
  };

  return PanoMenu;
}(_react["default"].PureComponent);

var _default = PanoMenu;
exports["default"] = _default;
module.exports = exports.default;